import {localStg} from '@/utils';
import configs from "@/configs";

const THEME_SETTINGS_VERSION = 2;

export function initThemeSettings() {
  const storageSettings = localStg.get('themeSettings') as any;

  // Force shell-related defaults when cache is stale / from old layout
  if (storageSettings && storageSettings.__version === THEME_SETTINGS_VERSION) {
    return storageSettings;
  }

  const next = {
    ...configs.theme,
    ...(storageSettings || {}),
    isToolbarDetached: false,
    isContentBoxed: false,
    __version: THEME_SETTINGS_VERSION,
  };

  localStg.set('themeSettings', next);
  return next;
}
